if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        this.initFullscreenViewer();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      initFullscreenViewer() {
        if (!this.elements.viewer) return;

        this.fullscreenImages = Array.from(
          this.elements.viewer.querySelectorAll('[data-media-id] img')
        );

        if (!this.fullscreenImages.length) return;

        this.fullscreenIndex = 0;

        this.fullscreenImages.forEach((image, index) => {
          image.style.cursor = 'zoom-in';

          image.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.openFullscreen(index);
          });
        });

        if (!document.querySelector('#gm-fullscreen-viewer')) {
          const viewer = document.createElement('div');

          viewer.id = 'gm-fullscreen-viewer';
          viewer.innerHTML = `
            <button
              class="gm-fullscreen-viewer__close"
              type="button"
              aria-label="Close image viewer"
            >
              ×
            </button>

            <button
              class="gm-fullscreen-viewer__nav gm-fullscreen-viewer__nav--prev"
              type="button"
              aria-label="Previous image"
            >
              ‹
            </button>

            <div class="gm-fullscreen-viewer__stage">
              <img
                class="gm-fullscreen-viewer__image"
                src=""
                alt=""
              >
            </div>

            <button
              class="gm-fullscreen-viewer__nav gm-fullscreen-viewer__nav--next"
              type="button"
              aria-label="Next image"
            >
              ›
            </button>
          `;

          document.body.appendChild(viewer);

          const style = document.createElement('style');

          style.textContent = `
            #gm-fullscreen-viewer {
              position: fixed;
              inset: 0;
              z-index: 999999;
              display: none;
              align-items: center;
              justify-content: center;
              background: rgba(16, 15, 13, 0.96);
              padding: 28px;
            }

            #gm-fullscreen-viewer.is-open {
              display: flex;
            }

            .gm-fullscreen-viewer__stage {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
            }

            .gm-fullscreen-viewer__image {
              display: block;
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              user-select: none;
              -webkit-user-drag: none;
            }

            .gm-fullscreen-viewer__close {
              position: absolute;
              top: 20px;
              right: 22px;
              z-index: 3;
              border: 0;
              background: transparent;
              color: #fff;
              font-size: 34px;
              line-height: 1;
              cursor: pointer;
              padding: 8px;
            }

            .gm-fullscreen-viewer__nav {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              z-index: 3;
              border: 0;
              background: transparent;
              color: #fff;
              font-size: 48px;
              line-height: 1;
              cursor: pointer;
              padding: 20px;
              opacity: 0.75;
            }

            .gm-fullscreen-viewer__nav:hover {
              opacity: 1;
            }

            .gm-fullscreen-viewer__nav--prev {
              left: 10px;
            }

            .gm-fullscreen-viewer__nav--next {
              right: 10px;
            }

            @media screen and (max-width: 749px) {
              #gm-fullscreen-viewer {
                padding: 18px 10px;
              }

              .gm-fullscreen-viewer__close {
                top: 10px;
                right: 10px;
                font-size: 30px;
              }

              .gm-fullscreen-viewer__nav {
                font-size: 40px;
                padding: 14px;
              }

              .gm-fullscreen-viewer__nav--prev {
                left: 0;
              }

              .gm-fullscreen-viewer__nav--next {
                right: 0;
              }
            }
          `;

          document.head.appendChild(style);
        }

        this.fullscreenViewer = document.querySelector('#gm-fullscreen-viewer');
        this.fullscreenViewerImage = this.fullscreenViewer.querySelector(
          '.gm-fullscreen-viewer__image'
        );

        this.fullscreenViewer
          .querySelector('.gm-fullscreen-viewer__close')
          .addEventListener('click', () => this.closeFullscreen());

        this.fullscreenViewer
          .querySelector('.gm-fullscreen-viewer__nav--prev')
          .addEventListener('click', () => this.changeFullscreenImage(-1));

        this.fullscreenViewer
          .querySelector('.gm-fullscreen-viewer__nav--next')
          .addEventListener('click', () => this.changeFullscreenImage(1));

        this.fullscreenViewer.addEventListener('click', (event) => {
          if (event.target === this.fullscreenViewer) {
            this.closeFullscreen();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (!this.fullscreenViewer.classList.contains('is-open')) return;

          if (event.key === 'Escape') {
            this.closeFullscreen();
          }

          if (event.key === 'ArrowLeft') {
            this.changeFullscreenImage(-1);
          }

          if (event.key === 'ArrowRight') {
            this.changeFullscreenImage(1);
          }
        });

        let touchStartX = 0;
        let touchEndX = 0;

        this.fullscreenViewer.addEventListener(
          'touchstart',
          (event) => {
            touchStartX = event.changedTouches[0].screenX;
          },
          { passive: true }
        );

        this.fullscreenViewer.addEventListener(
          'touchend',
          (event) => {
            touchEndX = event.changedTouches[0].screenX;

            const difference = touchStartX - touchEndX;

            if (Math.abs(difference) < 50) return;

            if (difference > 0) {
              this.changeFullscreenImage(1);
            } else {
              this.changeFullscreenImage(-1);
            }
          },
          { passive: true }
        );
      }

      openFullscreen(index) {
        if (!this.fullscreenViewer || !this.fullscreenImages.length) return;

        this.fullscreenIndex = index;

        this.updateFullscreenImage();

        this.fullscreenViewer.classList.add('is-open');
        this.fullscreenViewer.setAttribute('aria-hidden', 'false');

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      closeFullscreen() {
        if (!this.fullscreenViewer) return;

        this.fullscreenViewer.classList.remove('is-open');
        this.fullscreenViewer.setAttribute('aria-hidden', 'true');

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }

      changeFullscreenImage(direction) {
        if (!this.fullscreenImages.length) return;

        this.fullscreenIndex += direction;

        if (this.fullscreenIndex < 0) {
          this.fullscreenIndex = this.fullscreenImages.length - 1;
        }

        if (this.fullscreenIndex >= this.fullscreenImages.length) {
          this.fullscreenIndex = 0;
        }

        this.updateFullscreenImage();
      }

      updateFullscreenImage() {
        const sourceImage = this.fullscreenImages[this.fullscreenIndex];

        if (!sourceImage) return;

        const bestSource =
          sourceImage.currentSrc ||
          sourceImage.srcset
            ?.split(',')
            .pop()
            ?.trim()
            .split(' ')[0] ||
          sourceImage.src;

        this.fullscreenViewerImage.src = bestSource;
        this.fullscreenViewerImage.alt = sourceImage.alt || '';
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) =>
            element.removeAttribute('aria-current')
          );

        thumbnail
          .querySelector('button')
          .setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}